import { render, staticRenderFns } from "./IframePage.vue?vue&type=template&id=116695db&scoped=true&"
import script from "./IframePage.vue?vue&type=script&lang=js&"
export * from "./IframePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116695db",
  null
  
)

export default component.exports